import { Outlet } from 'react-router-dom';

export const HeaderlessLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
